/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BeneficiaryModel = {
    Id?: string;
    FullName?: string;
    FirstName?: string;
    MiddleName?: string | null;
    LastName?: string;
    EntityName?: string;
    Ssn?: string | null;
    SharePercentage?: number;
    EffectiveDate?: string | null;
    DateOfBirth?: string | null;
    BeneficiaryLevel?: BeneficiaryModel.BeneficiaryLevel;
    BeneficiaryType?: BeneficiaryModel.BeneficiaryType;
    Relationship?: string;
    Address?: string;
    City?: string;
    State?: string;
    ZipCode?: string;
    PhoneNumber?: string;
    Email?: string;
};
export namespace BeneficiaryModel {
    export enum BeneficiaryLevel {
        UNKNOWN = 'Unknown',
        PRIMARY = 'Primary',
        SECONDARY = 'Secondary',
        DEPOSITOR = 'Depositor',
        RESONSIBLE_PARTY = 'ResonsibleParty',
        SOLO401K = 'Solo401k',
    }
    export enum BeneficiaryType {
        UNKNOWN = 'Unknown',
        PERSON = 'Person',
        ENTITY = 'Entity',
    }
}

